/* components/ui/Select.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	bubble,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	select_option,
	select_value,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Prop from "./Prop.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (18:4) {#each options as item}
function create_each_block(ctx) {
	let option;

	let t0_value = (/*item*/ ctx[5] && /*item*/ ctx[5].name != null
	? /*item*/ ctx[5].name
	: /*item*/ ctx[5]) + "";

	let t0;
	let t1;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();

			option.__value = option_value_value = /*item*/ ctx[5] && /*item*/ ctx[5].value != null
			? /*item*/ ctx[5].value
			: /*item*/ ctx[5];

			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*options*/ 4 && t0_value !== (t0_value = (/*item*/ ctx[5] && /*item*/ ctx[5].name != null
			? /*item*/ ctx[5].name
			: /*item*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (dirty & /*options*/ 4 && option_value_value !== (option_value_value = /*item*/ ctx[5] && /*item*/ ctx[5].value != null
			? /*item*/ ctx[5].value
			: /*item*/ ctx[5])) {
				option.__value = option_value_value;
				option.value = option.__value;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (16:0) <Prop {label}>
function create_default_slot(ctx) {
	let select;
	let mounted;
	let dispose;
	let each_value = /*options*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			select = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(select, "class", "svelte-itz3o9");
			if (/*value*/ ctx[0] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[4].call(select));
		},
		m(target, anchor) {
			insert(target, select, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			select_option(select, /*value*/ ctx[0]);

			if (!mounted) {
				dispose = [
					listen(select, "change", /*select_change_handler*/ ctx[4]),
					listen(select, "change", /*change_handler*/ ctx[3])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*options*/ 4) {
				each_value = /*options*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*value, options*/ 5) {
				select_option(select, /*value*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) detach(select);
			destroy_each(each_blocks, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let prop;
	let current;

	prop = new Prop({
			props: {
				label: /*label*/ ctx[1],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(prop.$$.fragment);
		},
		m(target, anchor) {
			mount_component(prop, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const prop_changes = {};
			if (dirty & /*label*/ 2) prop_changes.label = /*label*/ ctx[1];

			if (dirty & /*$$scope, value, options*/ 261) {
				prop_changes.$$scope = { dirty, ctx };
			}

			prop.$set(prop_changes);
		},
		i(local) {
			if (current) return;
			transition_in(prop.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prop.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(prop, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { label = "" } = $$props;
	let { options = [] } = $$props;
	let { value = undefined } = $$props;

	function change_handler(event) {
		bubble($$self, event);
	}

	function select_change_handler() {
		value = select_value(this);
		$$invalidate(0, value);
		$$invalidate(2, options);
	}

	$$self.$$set = $$props => {
		if ("label" in $$props) $$invalidate(1, label = $$props.label);
		if ("options" in $$props) $$invalidate(2, options = $$props.options);
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
	};

	return [value, label, options, change_handler, select_change_handler];
}

class Select extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { label: 1, options: 2, value: 0 });
	}
}

export default Select;